import translationKeys from '@translationKeys'

import { UpdatesTableConfigProps } from './types'

export const tableColumnsConfig: UpdatesTableConfigProps[] = [
  {
    fieldName: 'profile',
    isEnabled: true,
    columnTitle: translationKeys.UPDATES_TABLE_HEADER_ITEM,
    restCellProps: { $nowrap: true },
    isSortable: false,
  },
  {
    fieldName: 'updates',
    isEnabled: true,
    columnTitle: translationKeys.UPDATES_TABLE_HEADER_UPDATES,
    restCellProps: {},
    isSortable: false,
  },
  {
    fieldName: 'updatedAt',
    isEnabled: true,
    columnTitle: translationKeys.UPDATES_TABLE_HEADER_LAST_UPDATED,
    restCellProps: {},
    isSortable: false,
  },
  {
    fieldName: 'unread',
    isEnabled: true,
    columnTitle: translationKeys.UPDATES_TABLE_HEADER_READ,
    restCellProps: { $cellWidth: 50, $fixedWidth: true },
    isSortable: false,
  },
]
